import React, { useEffect, useState } from 'react'
import './index.scss'
import { useFormContext } from 'react-hook-form'
import clsx from 'clsx'
import { ICONS } from '@Const/common'
import { doesFieldHaveFocus } from '@App/common/utils'
import { FormFieldProps } from '@App/forms/common/form-field'
import FieldErrorSectionForm from '@App/kit/fields/FieldErrorSectionForm'

const InputForm = (props: FormFieldProps) => {
    const { register, watch, setValue } = useFormContext()
    const [hasFocus, setFocus] = useState(false)
    const {
        name,
        label,
        mainColor = true,
        placeholder,
        assistiveText,
        registerOptions,
        assistiveTextFunction,
        assistiveTextVisibility,
    } = props

    useEffect(() => {
        setFocus(doesFieldHaveFocus(name))
    }, [])

    const classNamesForOuterDiv = clsx(
        'input-form-component',
        mainColor ? 'main-color-set' : 'second-color-set',
        'submit',
        hasFocus && 'focused'
    )
    const watchName = watch(name)

    const required = !!registerOptions && !!registerOptions.required
    const displayAssistiveText = assistiveText ?? (assistiveTextFunction ? assistiveTextFunction(required) : undefined)

    return (
        <div className={classNamesForOuterDiv}>
            <label className="small-2 medium" htmlFor={name}>
                {label}
            </label>
            <div className="input-wrapper-for-input-form">
                <input
                    {...register(name, registerOptions)}
                    placeholder={placeholder}
                    onFocus={() => setFocus(true)}
                    onBlur={() => setFocus(false)}
                />
                {watchName && (
                    <img onClick={() => setValue(name, '')} className="remove-value" src={ICONS.close} alt="close" />
                )}
            </div>
            <FieldErrorSectionForm
                name={name}
                assistiveText={displayAssistiveText}
                visibility={assistiveTextVisibility}
                required={required}
            />
        </div>
    )
}

export default InputForm
